import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import RegistrationSection from '../components/ui/RegistrationSection';
import { isRegistrationVisible } from './holidayRegistration';

function renderRegistrationInGrid(holiday) {
  if (!isRegistrationVisible(holiday)) return null;
  return <RegistrationSection registration={holiday.registration} />;
}

export const renderSchedule = (holiday) => {
  const { schedule } = holiday;

  if (!holiday.scheduleReady) {
    return (
      <div className="schedule-tbd">
        <div className="tbd-icon">📅</div>
        <h3>Schedule TBD</h3>
        <p>Please check back later for detailed schedules and events.</p>
        <div className="general-info">
          <div className="info-item">
            <FaCalendarAlt />
            <span><strong>Dates:</strong> {holiday.generalDates}</span>
          </div>
        </div>
      </div>
    );
  }

  const { scheduleDates } = holiday;

  if (schedule.roshHashanah || schedule.yomKippur || schedule.sukkot || schedule.simchatTorah) {
    return (
      <div className="schedule-container">
        {schedule.roshHashanah && schedule.roshHashanah.scheduleReady && (
          <div className="schedule-section">
            <h3>{scheduleDates.roshHashanah}</h3>
            {schedule.roshHashanah.events.map((item, index) => (
              <div key={index} className="schedule-item">
                <span className="date">{item.date}</span>
                <span className="time">{item.time}</span>
                <span className="event">{item.event}</span>
              </div>
            ))}
          </div>
        )}
        {schedule.yomKippur && schedule.yomKippur.scheduleReady && (
          <div className="schedule-section">
            <h3>{scheduleDates.yomKippur}</h3>
            {schedule.yomKippur.events.map((item, index) => (
              <div key={index} className="schedule-item">
                <span className="date">{item.date}</span>
                <span className="time">{item.time}</span>
                <span className="event">{item.event}</span>
              </div>
            ))}
          </div>
        )}
        {schedule.sukkot && schedule.sukkot.scheduleReady && (
          <div className="schedule-section">
            <h3>{scheduleDates.sukkot}</h3>
            {schedule.sukkot.events.map((item, index) => (
              <div key={index} className="schedule-item">
                <span className="date">{item.date}</span>
                <span className="time">{item.time}</span>
                <span className="event">{item.event}</span>
              </div>
            ))}
          </div>
        )}
        {schedule.simchatTorah && schedule.simchatTorah.scheduleReady && (
          <div className="schedule-section">
            <h3>{scheduleDates.simchatTorah}</h3>
            {schedule.simchatTorah.events.map((item, index) => (
              <div key={index} className="schedule-item">
                <span className="date">{item.date}</span>
                <span className="time">{item.time}</span>
                <span className="event">{item.event}</span>
              </div>
            ))}
          </div>
        )}
        {!schedule.sukkot?.scheduleReady && (
          <div className="schedule-tbd">
            <p>Sukkot schedule coming soon!</p>
          </div>
        )}
        {!schedule.simchatTorah?.scheduleReady && (
          <div className="schedule-tbd">
            <p>Simchat Torah schedule coming soon!</p>
          </div>
        )}
        {renderRegistrationInGrid(holiday)}
      </div>
    );
  }

  if (schedule.fridays && schedule.saturdays) {
    return (
      <div className="schedule-container">
        <div className="schedule-section">
          <h3>Fridays</h3>
          {schedule.fridays.map((item, index) => (
            <div key={index} className="schedule-item">
              <span className="time">{item.time}</span>
              <span className="event">{item.event}</span>
            </div>
          ))}
        </div>
        <div className="schedule-section">
          <h3>Saturdays</h3>
          {schedule.saturdays.map((item, index) => (
            <div key={index} className="schedule-item">
              <span className="time">{item.time}</span>
              <span className="event">{item.event}</span>
            </div>
          ))}
        </div>
        {schedule.services && (
          <div className="schedule-section">
            <h3>Service Locations</h3>
            {schedule.services.map((service, index) => (
              <div key={index} className="schedule-item">
                <span className="denomination">{service.denomination}</span>
                <span className="location">{service.location}</span>
              </div>
            ))}
          </div>
        )}
        {renderRegistrationInGrid(holiday)}
      </div>
    );
  }

  if (schedule.events && Array.isArray(schedule.events)) {
    return (
      <div className="schedule-container">
        <div className="schedule-section">
          {schedule.events.map((item, index) => (
            <div key={index} className="schedule-item">
              {item.date && <span className="date">{item.date}</span>}
              {item.time && <span className="time">{item.time}</span>}
              <span className="event">{item.event}</span>
            </div>
          ))}
        </div>
        {renderRegistrationInGrid(holiday)}
      </div>
    );
  }
};
